
import {createSlice} from "@reduxjs/toolkit";

export const usersSlice = createSlice({
    name: 'usersSlc',
    initialState: {value: {id: 0, firstName: null, lastName: null, department: null,
            role: null, rights: null, status: null, approvalLimit: null, userName: null,
            password: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            usersDrawerState: false, usersDrawerMode: null, usersGridRefresh: false
        }},
    reducers:
{
    changeUsers: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeUsers } = usersSlice.actions;

export default  usersSlice.reducer ;
